import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/AlertsContentViewQuery.graphql';
import type { PreloadParams } from './AlertsContentViewQuery.tsx';

export const asyncAlertsContentViewQuery = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-nav4-alerts-content-view-query" */ './AlertsContentViewQuery'
		).then(({ AlertsContentViewQuery }) => AlertsContentViewQuery),
	),
	getPreloadProps: ({ cloudId }: PreloadParams) => ({
		queries: {
			queryRef: {
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
